const initialState = {
  bookmarkFilterId: null,
  triggerKey: 0,
};

export default function bookmarkFilter(state = initialState, action) {
  switch (action.type) {
    case "@@INIT":
      return initialState;
    case "SET_BOOKMARK_FILTER_ID":
      return { ...state, bookmarkFilterId: action.payload };
    case "CLEAR_BOOKMARK_FILTER_ID":
      return { ...state, bookmarkFilterId: null };
    case "TRIGGER_BOOKMARK_EFFECT":
      return { ...state, triggerKey: state.triggerKey + 1 };
    default:
      return state;
  }
}
